module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#listicle",
      toString: function () {
        return this.url;
      }
    }